module.exports = __webpack_public_path__ + "static/media/perfil_waliff.b7b52636.png";